// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: events_app/events_app.proto

/* eslint-disable */
import type { User } from "../common/users";

export interface Event {
  id: string;
  title: string;
  description?: string | undefined;
  maxCapacity?: number | undefined;
  recordingUrl?: string | undefined;
  thumbnailUrl?: string | undefined;
  recurringRule?: Event_RecurringRule | undefined;
  rrule?: string | undefined;
  seriesEndsAt?: string | undefined;
  startsAt: string | undefined;
  endsAt: string | undefined;
  location?: string | undefined;
  locationType: Event_LocationType;
  rsvpsCount: number;
  rsvpUsers: User[];
  hostName?: string | undefined;
  hostUser?: User | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export const Event_LocationType = {
  UNKNOWN_LOCATION_TYPE: "UNKNOWN_LOCATION_TYPE",
  OFFLINE: "OFFLINE",
  ONLINE: "ONLINE",
  ZOOM: "ZOOM",
  GOOGLE_MEET: "GOOGLE_MEET",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Event_LocationType = typeof Event_LocationType[keyof typeof Event_LocationType];

export namespace Event_LocationType {
  export type UNKNOWN_LOCATION_TYPE = typeof Event_LocationType.UNKNOWN_LOCATION_TYPE;
  export type OFFLINE = typeof Event_LocationType.OFFLINE;
  export type ONLINE = typeof Event_LocationType.ONLINE;
  export type ZOOM = typeof Event_LocationType.ZOOM;
  export type GOOGLE_MEET = typeof Event_LocationType.GOOGLE_MEET;
  export type UNRECOGNIZED = typeof Event_LocationType.UNRECOGNIZED;
}

export const Event_RecurringRule = {
  UNKNOWN_RECURRING_RULE: "UNKNOWN_RECURRING_RULE",
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Event_RecurringRule = typeof Event_RecurringRule[keyof typeof Event_RecurringRule];

export namespace Event_RecurringRule {
  export type UNKNOWN_RECURRING_RULE = typeof Event_RecurringRule.UNKNOWN_RECURRING_RULE;
  export type DAILY = typeof Event_RecurringRule.DAILY;
  export type WEEKLY = typeof Event_RecurringRule.WEEKLY;
  export type MONTHLY = typeof Event_RecurringRule.MONTHLY;
  export type YEARLY = typeof Event_RecurringRule.YEARLY;
  export type UNRECOGNIZED = typeof Event_RecurringRule.UNRECOGNIZED;
}
